import React from "react";
import * as Icons from "react-bootstrap-icons";
import { useDispatch } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import { HandleLogOut } from "Utils/Helpers/HandleLogin";
import { useNavigate } from "react-router-dom";

export default function Logout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onLogout = () => {
    dispatch(HandleLogOut(navigate));
  }

  return (
    <div onClick={onLogout} className="btn-manager btn-manager-danger">
    <Tooltip title={"Log out"}>
      <Icons.Power size={25} />
    </Tooltip>
  </div>
  );
}
